import { render, staticRenderFns } from "./NepaliDatePicker.vue?vue&type=template&id=a0472080&scoped=true"
import script from "./NepaliDatePicker.vue?vue&type=script&lang=js"
export * from "./NepaliDatePicker.vue?vue&type=script&lang=js"
import style0 from "./NepaliDatePicker.vue?vue&type=style&index=0&id=a0472080&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0472080",
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QField,QInput});
